import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.4 16.2568C11.4729 16.3328 11.5645 16.3941 11.6682 16.4361C11.772 16.4782 11.8853 16.5 12 16.5C12.1147 16.5 12.228 16.4782 12.3318 16.4361C12.4355 16.3941 12.5271 16.3328 12.6 16.2568L19.35 8.53021C19.4336 8.43455 19.4845 8.3208 19.497 8.2017C19.5095 8.08261 19.4831 7.96288 19.4208 7.85593C19.3585 7.74898 19.2628 7.65903 19.1443 7.59616C19.0258 7.5333 18.8893 7.5 18.75 7.5L5.25 7.5C5.11072 7.5 4.97418 7.5333 4.8557 7.59616C4.73722 7.65903 4.64147 7.74898 4.57918 7.85593C4.51689 7.96288 4.49052 8.08261 4.50303 8.2017C4.51554 8.3208 4.56643 8.43455 4.65 8.53021L11.4 16.2568Z",
		fill: "#636C7B"
	})
});
export default SvgTriangleDown;
